export function parseCharset(wordbank) {
  const keys = {};
  for (const word of wordbank) {
    for (const ch of word.split("")) {
      keys[ch] = ch;
    }
  }
  return Object.keys(keys).map((k) => ({ key: k, state: -1 }));
}

export function getLongest(words) {
  if (words.length < 1) {
    return 0;
  }
  let len = words[0].length;
  for (const word of words) {
    if (word.length > len) {
      len = word.length;
    }
  }
  return len;
}

export function segment(list, n) {
  let len = Math.ceil(list.length / n);
  let segments = [];
  for (let i = 0; i < n; i++) {
    segments.push(list.slice(i * len, Math.min(i * len + len, list.length)));
  }
  return segments;
}

export const compare = (solution, input) => {
  const solutionChars = solution.split("");

  const solutionCounts = solutionChars.reduce((acc, ch) => {
    acc[ch] = acc[ch] || 0;
    acc[ch] += 1;
    return acc;
  }, {});

  const inputCounts = {};

  const inputChars = input.split("");

  const result = new Array(inputChars.length);

  const visited = new Array(inputChars.length).fill(false);

  for (let i = 0; i < inputChars.length; i++) {
    const ch = inputChars[i];

    if (ch === solutionChars[i]) {
      result[i] = {
        char: ch,
        match: 2
      };
      inputCounts[ch] = inputCounts[ch] || 0;
      inputCounts[ch] += 1;
      visited[i] = true;
    }
  }

  for (let i = 0; i < inputChars.length; i++) {
    const ch = inputChars[i];

    if (visited[i]) {
      continue;
    } else if ((inputCounts[ch] || 0) < (solutionCounts[ch] || 0)) {
      result[i] = {
        char: ch,
        match: 1
      };
      inputCounts[ch] = inputCounts[ch] || 0;
      inputCounts[ch] += 1;
    } else {
      result[i] = {
        char: ch,
        match: 0
      };
      inputCounts[ch] = inputCounts[ch] || 0;
      inputCounts[ch] += 1;
    }
  }
  return result;
};

export function xmur3(str) {
  for (var i = 0, h = 1779033703 ^ str.length; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return function () {
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    return (h ^= h >>> 16) >>> 0;
  };
}

export function sfc32(a, b, c, d) {
  return function () {
    a >>>= 0;
    b >>>= 0;
    c >>>= 0;
    d >>>= 0;
    var t = (a + b) | 0;
    a = b ^ (b >>> 9);
    b = (c + (c << 3)) | 0;
    c = (c << 21) | (c >>> 11);
    d = (d + 1) | 0;
    t = (t + d) | 0;
    c = (c + t) | 0;
    return (t >>> 0) / 4294967296;
  };
}

export function getSolutionIndex(length, state) {
  const seed = xmur3(state);
  const rand = sfc32(seed(), seed(), seed(), seed());
  const r = rand();
  return Math.floor(r * length);
}

export function generateState(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function stateToColor(state) {
  switch (state) {
    case 2:
      return "bg-green-500";
    case 1:
      return "bg-yellow-500";
    case 0:
      return "bg-slate-400";
    default:
      return "bg-slate-200";
  }
}

export function uniq(list) {
  const visited = {};
  const newlist = [];
  for (const el of list) {
    if (visited[el]) {
      continue;
    }

    visited[el] = true;
    newlist.push(el);
  }
  return newlist;
}

// Copies a string to the clipboard. Must be called from within an
// event handler such as click. May return false if it failed, but
// this is not always possible. Browser support for Chrome 43+,
// Firefox 42+, Safari 10+, Edge and Internet Explorer 10+.
// Internet Explorer: The clipboard feature may be disabled by
// an administrator. By default a prompt is shown the first
// time the clipboard is used (per session).
export function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return prompt("Copy to clipboard: Ctrl+C, Enter", text);
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

/*
{
  "(": {
    "#": {
      "`": {
        "Д": {
          "´": {
            ")": {
            }
          }
        }
      }
    }
  }
}
*/
const LEAF = "$END$";

export function makeTrie(wordbank) {
  const trie = {};
  for (const word of wordbank) {
    let digger = trie;
    for (const char of word.split("")) {
      digger[char] = digger[char] || {};
      digger = digger[char];
    }
    digger[LEAF] = true;
  }
  return trie;
}

export function getAvailableKeys(trie, guess) {
  let node = trie;
  for (const char of guess) {
    node = node[char] || {};
  }
  return Object.keys(node);
}

export function isValidKaomoji(trie, guess) {
  let node = trie;
  for (const char of guess) {
    node = node[char] || {};
  }
  return node[LEAF] || false;
}
